/**
 * 프리렌더된 HTML 을 hydrate 했는지 — 첫 화면에서 이미 보이는 글을 다시 숨겼다 드러내는
 * 인트로 애니메이션을 건너뛰기 위해 쓴다.
 *
 * 한 번만 소비된다: 같은 경로라도 앱 안에서 다시 들어오면(예: / → /guide → /) 그때는
 * 프리렌더 마크업이 아니라 새로 그린 화면이라 인트로를 보여 준다.
 */
let prerenderedPath: string | null = null;

export function markPrerendered(path: string): void {
  prerenderedPath = path;
}

export function takePrerendered(path: string): boolean {
  if (prerenderedPath !== path) return false;
  prerenderedPath = null;
  return true;
}
